/**
 * 全局默认行为
 */
require([
    'zepto',
    'util/client-init',
    'util/extend',
    'lib/fastclick'
], function($, clientInit, extend, FastClick) {
    // 客户端初始化
    clientInit();
    // fastClick
    FastClick.attach(document.body);
});

define("js/entry/default", function(){});

